/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Tips_TitleInputs */

const tr_katalog_desi_page_tips_title = /** @type {(inputs: Katalog_Desi_Page_Tips_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İpuçları`)
};

const en_katalog_desi_page_tips_title = /** @type {(inputs: Katalog_Desi_Page_Tips_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips`)
};

const de_katalog_desi_page_tips_title = /** @type {(inputs: Katalog_Desi_Page_Tips_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipps`)
};

const ru_katalog_desi_page_tips_title = /** @type {(inputs: Katalog_Desi_Page_Tips_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Советы`)
};

/**
* | output |
* | --- |
* | "Tips" |
*
* @param {Katalog_Desi_Page_Tips_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_tips_title = /** @type {((inputs?: Katalog_Desi_Page_Tips_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Tips_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_tips_title(inputs)
	if (locale === "de") return de_katalog_desi_page_tips_title(inputs)
	if (locale === "ru") return ru_katalog_desi_page_tips_title(inputs)
	return tr_katalog_desi_page_tips_title(inputs)
});